import { c as _c } from "react/compiler-runtime";
import React, { type ReactElement, forwardRef } from 'react';
import { type DotsLoaderProps } from './types';
import { StyledDivLoaderContainer } from './styles';
import { useTheme } from '../../utils/useTheme';
const DotsLoader = forwardRef<HTMLDivElement, DotsLoaderProps>((t0, ref) => {
  const $ = _c(31);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      height: t1,
      width: t2,
      radius: t3,
      surface: t4,
      dataTestId: t5,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  const height = t1 === undefined ? 40 : t1;
  const width = t2 === undefined ? 40 : t2;
  const radius = t3 === undefined ? 10 : t3;
  const surface = t4 === undefined ? "default" : t4;
  const dataTestId = t5 === undefined ? "three-dots-loading" : t5;
  const theme = useTheme();
  const resolvedColor = surface === "brand" ? theme.tokens.foreground.main.staticWhite : theme.tokens.background.brand.main.default;
  const t6 = Number(radius) + 6;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <animate attributeName="r" from="15" to="15" begin="0s" dur="1.5s" values="15;9;15" calcMode="linear" repeatCount="indefinite" />;
    t8 = <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="1.5s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t6) {
    t9 = <circle cx="15" cy="15" r={t6}>{t7}{t8}</circle>;
    $[9] = t6;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <animate attributeName="r" from="9" to="9" begin="0s" dur="1.5s" values="9;15;9" calcMode="linear" repeatCount="indefinite" />;
    t11 = <animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="1.5s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite" />;
    $[11] = t10;
    $[12] = t11;
  } else {
    t10 = $[11];
    t11 = $[12];
  }
  let t12;
  if ($[13] !== radius) {
    t12 = <circle cx="60" cy="15" r={radius} attributeName="fill-opacity" from="1" to="0.3">{t10}{t11}</circle>;
    $[13] = radius;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = Number(radius) + 6;
  let t14;
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <animate attributeName="r" from="15" to="15" begin="0s" dur="1.5s" values="15;9;15" calcMode="linear" repeatCount="indefinite" />;
    t15 = <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="1.5" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />;
    $[15] = t14;
    $[16] = t15;
  } else {
    t14 = $[15];
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t13) {
    t16 = <circle cx="105" cy="15" r={t13}>{t14}{t15}</circle>;
    $[17] = t13;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== dataTestId || $[20] !== height || $[21] !== resolvedColor || $[22] !== t12 || $[23] !== t16 || $[24] !== t9 || $[25] !== width) {
    t17 = <svg width={width} height={height} viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" fill={resolvedColor} data-testid={dataTestId}>{t9}{t12}{t16}</svg>;
    $[19] = dataTestId;
    $[20] = height;
    $[21] = resolvedColor;
    $[22] = t12;
    $[23] = t16;
    $[24] = t9;
    $[25] = width;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== props || $[28] !== ref || $[29] !== t17) {
    t18 = <StyledDivLoaderContainer ref={ref} {...props}>{t17}</StyledDivLoaderContainer>;
    $[27] = props;
    $[28] = ref;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
});
export default DotsLoader;
export { DotsLoader };